export default __webpack_public_path__ + "cb5054ed29d4b8d16c8397413d4c16ed.png";